/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type MarkersOutUnavailableCode = typeof MarkersOutUnavailableCode[keyof typeof MarkersOutUnavailableCode] | null;


export const MarkersOutUnavailableCode = {
  processing: 'processing',
  purged: 'purged',
  swept: 'swept',
  unreadable: 'unreadable',
} as const;
